// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Company audit log page component.
 * Displays the audit history for a specific company.
 */
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { CustomerAuditList } from '@/customer/components/customer-audit-list';
import { CustomerErrorBoundary } from '@/customer/components/customer-error-boundary';
import { Stack } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

export const Route = createFileRoute('/_app/companies/$companyKey/audit')({
  component: CompanyAuditRoute,
});

function CompanyAuditRoute() {
  const { companyKey } = Route.useParams();

  return (
    <CustomerErrorBoundary>
      <CompanyAuditContent companyKey={companyKey} />
    </CustomerErrorBoundary>
  );
}

function CompanyAuditContent(props: { companyKey: string }) {
  return (
    <HardfinTabCardWrapper title="Audit log">
      <Stack paddingTop={2}>
        <Suspense>
          <CustomerAuditList customerKey={props.companyKey} />
        </Suspense>
      </Stack>
    </HardfinTabCardWrapper>
  );
}
